import React from 'react';

import ErrorView from './ErrorView';

const Whoops = () => {
  return <ErrorView code={500} message={'Sorry something went wrong'} />;
};

export default Whoops;
